import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';

import ReferenceBar from '/@/components/crop-monitoring/reference-bar';
import ToggleGroup from '/@/components/forms/toggle-group';
import Section from '/@/components/section';
import colors from '/@/components/theme-provider/colors';
import Title from '/@/components/title';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import BarChart from '../../charts/bar-chart';
import styles from './styles.module.css';

@autobind
export default class Yield extends Component {
    static propTypes = {
        user: PropTypes.shape({
            email: PropTypes.string.isRequired,
        }).isRequired,
        headToHeads: PropTypes.arrayOf(PropTypes.object).isRequired,
        brands: PropTypes.arrayOf(PropTypes.number),
        brandOptions: PropTypes.arrayOf(
            PropTypes.shape({
                value: PropTypes.number.isRequired,
                label: PropTypes.string.isRequired,
            })
        ),
        setBrands: PropTypes.func,
        biotechnologies: PropTypes.arrayOf(PropTypes.number),
        biotechnologyOptions: PropTypes.arrayOf(
            PropTypes.shape({
                value: PropTypes.number.isRequired,
                label: PropTypes.string.isRequired,
            })
        ),
        setBiotechnologies: PropTypes.func,
        onLinearRegressionClick: PropTypes.func,
        title: PropTypes.string,
    };

    static defaultProps = {
        brandOptions: [],
        biotechnologyOptions: [],
    };

    static contextTypes = {
        units: PropTypes.object.isRequired,
    };

    renderFilters() {
        const { brands, brandOptions, setBrands, biotechnologies, biotechnologyOptions, setBiotechnologies } =
            this.props;

        const references = [
            { text: _('Gana'), color: colors.success[200] },
            { text: _('Diferencia no significativa'), color: colors.warning[600] },
            { text: _('Pierde'), color: colors.warning[700] },
        ];

        return (
            <div className={styles.filters}>
                {brandOptions.length > 0 && (
                    <div className={styles.filter}>
                        <Title>{_('Marca')}</Title>
                        <ToggleGroup
                            type='checkbox'
                            theme={settings.app.theme}
                            options={brandOptions}
                            value={brands}
                            onChange={setBrands}
                        />
                    </div>
                )}
                <ReferenceBar sx={{ margin: 0, width: '100%', fontSize: '14px' }} references={references} />
                {biotechnologyOptions.length > 0 && (
                    <div className={styles.filter}>
                        <Title>{_('Biotecnología')}</Title>
                        <ToggleGroup
                            type='checkbox'
                            options={biotechnologyOptions}
                            value={biotechnologies}
                            onChange={setBiotechnologies}
                        />
                    </div>
                )}
            </div>
        );
    }

    renderChart() {
        const { headToHeads, user, crop, onLinearRegressionClick, title } = this.props;
        return (
            <div>
                {!!title && <div className={styles.H2HTitle}>{title}</div>}
                <BarChart
                    user={user}
                    data={headToHeads}
                    renderValue={(value) => this.context.units.toYield(value, crop).toString()}
                    onLinearRegressionClick={onLinearRegressionClick}
                    showWinRate
                />
            </div>
        );
    }

    render() {
        return (
            <Section title={_('Rendimiento')}>
                <div className={styles.root}>
                    {this.renderFilters()}
                    {this.renderChart()}
                </div>
            </Section>
        );
    }
}
